import { classNames } from "primereact/utils";

import { Kanban, LoadingState } from "@/ds";

import { ObraCard } from "../obra-card";
import {
  OBRAS_KANBAN_EMPTY_COLUMN_MESSAGE,
  OBRAS_KANBAN_LOAD_MORE_LABEL,
  OBRAS_KANBAN_LOADING_LABEL,
} from "./obras-kanban-board.constants";
import styles from "./obras-kanban-board.module.scss";
import type { ObrasKanbanBoardProps } from "./types-obras-kanban-board";

export function ObrasKanbanBoardView({
  device,
  isLoading = false,
  columns,
  testId,
  className,
  ...rest
}: ObrasKanbanBoardProps) {
  if (isLoading) {
    return (
      <div className={classNames(styles.boardLoading, className)} {...rest} data-testid={testId}>
        <LoadingState label={OBRAS_KANBAN_LOADING_LABEL} testId={`${testId}-loading`} />
      </div>
    );
  }

  return (
    <Kanban.Board
      device={device}
      bleed
      className={classNames(styles.board, className)}
      testId={testId}
      {...rest}
    >
      {columns.map((column) => (
        <Kanban.Column
          key={column.code}
          title={column.label}
          testId={column.testId}
          count={column.count}
          total={column.total}
          loading={column.isLoading}
          loadingLabel={OBRAS_KANBAN_LOADING_LABEL}
          error={column.errorMessage}
          emptyMessage={OBRAS_KANBAN_EMPTY_COLUMN_MESSAGE}
          loadMoreLabel={OBRAS_KANBAN_LOAD_MORE_LABEL}
          loadingMore={column.isLoadingMore}
          onLoadMore={column.loadMore}
        >
          {column.cards.map((card) => (
            <Kanban.Card key={card.key}>
              <ObraCard {...card.props} />
            </Kanban.Card>
          ))}
        </Kanban.Column>
      ))}
    </Kanban.Board>
  );
}
